import { WORKERS } from 'src/config-global';
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

export const getAllSites = async () =>
  (await axios.get(`${WORKERS.sites}/sites`)).data.data;
